<template>
    <div class="d-flex h-100 text-center flex-column align-items-center">
        <h2>QR Code para Check-In</h2>

        <label class="form form-control my-3">{{ link }}</label>

        <template v-if="link">
            <img :src="'https://chart.googleapis.com/chart?cht=qr&chl=' + encodeURIComponent(link) + '&choe=UTF-8&chs=400x400'" class="img-fluid mt-3">
        </template>
    </div>
</template>

<script>
export default {
    data() { 
        return { 
            unidade_operacao: null, 
            link: null, 
        }
    },

    props: ['id_unidade_operacao'],

    mounted() { 
        this.unidade_operacao = this.$store.state.unidade.unidade_operacaos.find(item => item.id_unidade_operacao == this.id_unidade_operacao);
        this.link = this.$store.state.unidade.check_in_link;
    }
}
</script>